/**
 * App version access.
 *
 * LESSON PINNED AT THE SCENE (Journal post-mortem §7): when the version lives in
 * more than one place — package.json, a UI constant, the service-worker cache name —
 * they drift, and the drift is invisible. The user then sees "v1.4" in the UI while
 * running the v1.3 bundle from a stale precache, and every support conversation
 * starts from a false premise. One source: /version.json, injected by the build as
 * __APP_VERSION__.
 */
/** The build-injected version, or 'dev' when running unbuilt (tests, dev server). */
export function appVersion() {
    return typeof __APP_VERSION__ === 'string' && __APP_VERSION__.length > 0 ? __APP_VERSION__ : 'dev';
}
/** Fails loudly in a production build if the injection did not happen. */
export function assertVersionInjected() {
    if (appVersion() === 'dev') {
        throw new Error('App version was not injected by the build. The SW revision, UI and Sentry release would all disagree.');
    }
}
//# sourceMappingURL=version.js.map